import { render, staticRenderFns } from "./garland.vue?vue&type=template&id=65dae544&"
import script from "./garland.vue?vue&type=script&lang=ts&"
export * from "./garland.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports